import type { ApiErrorResponse } from '../models/ApiError';
import { PlanErrorCode } from '../models/PlanErrorCodes';

export class PlanUpgradeError extends Error {
  readonly code: string;
  readonly feature?: string;
  readonly requiredAddOn?: string;
  readonly planType?: string;

  constructor(
    message: string,
    details: {
      code: string;
      feature?: string;
      requiredAddOn?: string;
      planType?: string;
    },
  ) {
    super(message);
    this.name = 'PlanUpgradeError';
    this.code = details.code;
    this.feature = details.feature;
    this.requiredAddOn = details.requiredAddOn;
    this.planType = details.planType;
  }
}

export function isPlanUpgradeError(error: unknown): error is PlanUpgradeError {
  return error instanceof PlanUpgradeError;
}

export function parseApiErrorBody(body: unknown, fallbackMessage: string): Error {
  if (!body || typeof body !== 'object') {
    return new Error(fallbackMessage);
  }

  const parsed = body as Partial<ApiErrorResponse>;
  const message = typeof parsed.error === 'string' ? parsed.error : fallbackMessage;

  if (
    parsed.code === PlanErrorCode.PLAN_UPGRADE_REQUIRED
    || parsed.code === PlanErrorCode.PLAN_FORBIDDEN_SHARING_MODE
  ) {
    return new PlanUpgradeError(message, {
      code: parsed.code,
      feature: parsed.meta?.feature,
      requiredAddOn: parsed.meta?.requiredAddOn,
      planType: parsed.meta?.planType,
    });
  }

  return new Error(message);
}
